var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import classNames from "classnames";
import styles from "./Icons.module.css";
function SpinningSVG(_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ className: classNames(styles.SpinningSVG, className) }, rest)));
}
export function WaitingIcon(_a) {
    var style = _a.style;
    return (React.createElement(SpinningSVG, { style: style, width: "100", height: "100", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "50", cy: "50", r: "50", fill: "#717874" }),
        React.createElement("circle", { cx: "50", cy: "50", r: "30", stroke: "white", strokeWidth: "5" }),
        React.createElement("path", { d: "M20.1228 55.6056L36.7284 53.7284L18.2457 72.2112L3.51725 57.4827L20.1228 55.6056Z", fill: "#717874" }),
        React.createElement("path", { d: "M20.4854 50.4853H28.9706L20.4854 58.9706L12.0001 50.4853H20.4854Z", fill: "white" }),
        React.createElement("path", { d: "M84.041 28.4453L98.7979 43.2021L82.5205 44.7227L66.2432 46.2432L84.041 28.4453Z", fill: "#717874" }),
        React.createElement("path", { d: "M80.4854 42L88.9706 50.4853H80.4854H72.0001L80.4854 42Z", fill: "white" })));
}
export function CloseButtonSVG(_a) {
    var _b = _a.fill, fill = _b === void 0 ? "none" : _b, size = _a.size;
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: fill, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M4 4L12 12M20 20L12 12M12 12L4 20M12 12L20 4", stroke: "black", strokeWidth: "1.3" })));
}
export function CircularProgress(_a) {
    var _b = _a.size, size = _b === void 0 ? "100px" : _b, _c = _a.fill, fill = _c === void 0 ? "currentColor" : _c, className = _a.className, rest = __rest(_a, ["size", "fill", "className"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", width: size, height: size, className: classNames("inline-flex align-middle", className) }, rest),
        React.createElement("circle", { fill: "none", stroke: fill, strokeWidth: "4", cx: "50", cy: "50", r: "44" }),
        React.createElement("circle", { fill: fill, stroke: fill, strokeWidth: "3", cx: "8", cy: "54", r: "6" },
            React.createElement("animateTransform", { attributeName: "transform", dur: "2s", type: "rotate", from: "0 50 48", to: "360 50 52", repeatCount: "indefinite" }))));
}
